import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Modal, Spin } from "antd";
import styled from "styled-components";
import "antd/dist/antd.min.css";

const StyledModal = {
  confirm: async(title,content,onOkFunction,onCancelFunction,okText,cancelText) => {
    Modal.confirm({
      icon: <ExclamationCircleOutlined />,
      title: title,
      content: content,
      onOk: onOkFunction,
      onCancel: onCancelFunction,
      okText: okText,
      cancelText: cancelText,
    })
  },
  info: async(title, message) => {
    Modal.info({
      title: title,
      content: (
        <div>
          <p>{message}</p>
        </div>
      ),
      onOk() {},
    });
  },
  success: async(message) => {
    Modal.success({
      content: message,
    });
  },
  error: async(title, message) => {
    Modal.error({
      title: title,
      content: message,
    });
  },
  warning: async(title, message) => {
    Modal.warning({
      title: title,
      content: message,
    });
  },
  Spin: styled(Spin)``,
  Basic: styled(Modal)``,

};

export default StyledModal;
